import type { FontSize } from '@usealloy/component-library';
import {
  Box,
  Spinner,
  Text,
} from '@usealloy/component-library';
import React from 'react';

const LoadingView = ({ fontSize = 5 }: { fontSize?: FontSize }) => (
  <Box gap={4}>
    <Spinner />
    <Text as="h2" size={fontSize}>Loading...</Text>
  </Box>
);

export default LoadingView;
